export default function Progresbar({ progressPercentage = 0 }) {
  return (
    <div className="progress-bar-wrapper">
      <div
        className="progress-bar-fill"
        style={{
          width: `${progressPercentage}%`,
          backgroundColor: "#008CFF",
        }}
      ></div>
    </div>
  );
}
